import React, { Component, useState, useEffect } from 'react'
import Dropzone from 'react-dropzone'

import '../styles/react-select.scss'
import Select, { Creatable } from 'react-select'
import moment from 'moment'

import 'react-datetime/css/react-datetime.css'
import DateTime from 'react-datetime'
import historykana from 'historykana'
import { Field } from 'redux-form'
import * as validators from '../utils/validators'
import { toJpYearDate, toAdYearDate } from '../utils/jpYear'
import { LabelMapper } from './FormErrors'
import { Calendar, Fileup, Delete, CheckForm } from './icons'
import styles from './Form.scss'
import omit from 'lodash/omit'
import isString from 'lodash/isString'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import isEmpty from 'lodash/isEmpty'
import last from 'lodash/last'
import uniqueId from 'lodash/uniqueId'
import get from 'lodash/get'
import Hint from './Hint'

export const Diff = ({ diff, options }) =>
  diff ? (
    <div className={styles.diffField}>
      <p className={styles.diffLabelText}>変更前</p>
      <p>{!isEmpty(options) && options[diff] && typeof options[diff] !== 'object' ? options[diff] : diff}</p>
    </div>
  ) : null

export const Required = () => <span className={styles.required}>必須</span>

export const Label = ({ text, required, note, noteWidth, changed, noLabel, diff }) => (
  <React.Fragment>
    {!noLabel && (
      <div className={styles.label}>
        {text}
        {required && <Required />}
        {note && <Hint text={note} width={noteWidth} />}
        {(changed || diff) && (
          <span className={styles.changed}>
            <CheckForm />
            承認待ち
          </span>
        )}
      </div>
    )}
  </React.Fragment>
)

export const renderCheckBoxField = ({
  input,
  label,
  meta,
  labelContent,
  note,
  noteWidth,
  disabled,
  diff,
  changed,
  description
}) => (
  <div>
    <label className="input-label">
      <input
        {...input}
        placeholder={label}
        type="checkbox"
        checked={input.value}
        className="m-checkbox-input"
        disabled={disabled}
      />
      <span className="m-checkbox-parts">{labelContent ? labelContent : label}</span>
    </label>
    {note && <Hint text={note} width={noteWidth} />}
    {(changed || diff) && (
      <span className={styles.changed}>
        <CheckForm />
        承認待ち
      </span>
    )}
    <Diff diff={diff} />
    {description && <div className={styles.description}>{description}</div>}
    <Error meta={meta} label={label} />
  </div>
)

export const renderInputField = ({
  input,
  label,
  type,
  required,
  meta,
  readOnly,
  disabled,
  note,
  noteWidth,
  maxLength,
  yen,
  placeholder,
  icons,
  diff,
  changed,
  noLabel,
  description,
  isChangeLabelToAnchor
}) => (
  <div>
    <Label
      text={label}
      required={required}
      note={note}
      noteWidth={noteWidth}
      changed={changed}
      diff={diff}
      noLabel={noLabel}
      isChangeLabelToAnchor={isChangeLabelToAnchor}
    />
    <div className={styles.fieldWrap}>
      <div className={styles.icnTextarea}>
        {yen && <i className={styles.yen}>円</i>}
        <input
          {...{ readOnly, disabled, type, ...input }}
          className={meta.error && meta.touched ? styles.invalid : ''}
          maxLength={maxLength}
          placeholder={placeholder}
        />
      </div>
      {icons && <div className={styles.icons}>{icons}</div>}
    </div>
    <Diff diff={diff} />
    {description && <div className={styles.description}>{description}</div>}
    <Error meta={meta} label={label} />
  </div>
)

export const renderInputFieldWithKana = props => {
  const { input, onUpdateKana } = props
  const [history, setHistory] = useState([])
  useEffect(
    () => {
      if (input.value) {
        setHistory(history => [...history, input.value])
      } else {
        setHistory([])
        onUpdateKana('')
      }
    },
    [input.value]
  )
  useEffect(
    () => {
      const kana = history.length > 0 ? historykana(history) : ''
      if (kana) onUpdateKana(kana)
    },
    [history]
  )
  const InputField = renderInputField
  return <InputField {...props} />
}

export const renderInlineInputField = ({ input, type, width, maxLength, meta: { touched, error }, disabled }) => (
  <input
    {...input}
    type={type}
    style={{ display: 'inline-block', width: `${width}px` }}
    maxLength={maxLength}
    className={touched && error ? styles.invalid : ''}
    disabled={disabled}
  />
)

export const renderRadioField = ({
  label,
  input,
  options,
  disabled: disabledAll,
  required,
  meta,
  note,
  noteWidth,
  diff,
  changed,
  description,
  isDirectionColumn = false,
  isChangeLabelToAnchor
}) => (
  <div>
    <div className={styles.radio}>
      <Label
        text={label}
        required={required}
        note={note}
        noteWidth={noteWidth}
        changed={changed}
        diff={diff}
        isChangeLabelToAnchor={isChangeLabelToAnchor}
      />
      <div className={isDirectionColumn ? styles.directionColumn : ''}>
        {options.map(({ label, value, note, noteWidth, disabled: disabledOption }) => {
          const disabled = disabledAll || disabledOption
          return (
            <div style={{ display: 'inline-block' }} className={'input-label'} key={value}>
              <label>
                <input
                  {...omit(input, 'value')}
                  type="radio"
                  value={value}
                  checked={value == input.value}
                  disabled={disabled}
                  className={`m-radio-input${disabled ? ' disabled' : ''}`}
                />
                <span className={`m-radio-parts${disabled ? ' disabled' : ''}`}>{label}</span>
              </label>
              {note && <Hint text={note} width={noteWidth} />}
            </div>
          )
        })}
      </div>
    </div>
    <Diff diff={diff} options={options} />
    {description && <div className={styles.description}>{description}</div>}
    <Error meta={meta} label={label} />
  </div>
)

const JpYearDate = ({ value }) => {
  const dateMatch = value.match(validators.adYearRegExp)
  if (dateMatch && moment(value, 'YYYY/MM/DD').isValid()) {
    const date = new Date(dateMatch[1], Number(dateMatch[2]) - 1, dateMatch[3])
    return <span className={styles.jpYear}>{toJpYearDate(date)}</span>
  }
  return null
}

export class renderDatePickerField extends Component {
  render() {
    const {
      input,
      label,
      required,
      meta,
      note,
      noteWidth,
      dateFormat = 'YYYY/MM/DD',
      diff,
      changed,
      example,
      description,
      isChangeLabelToAnchor,
      disabled,
      ...rest
    } = this.props
    return (
      <div>
        <Label
          text={label}
          required={required}
          note={note}
          noteWidth={noteWidth}
          changed={changed}
          diff={diff}
          isChangeLabelToAnchor={isChangeLabelToAnchor}
        />
        <div
          className={meta.touched && meta.error ? `${styles.icnTextarea} ${styles.invalid}` : `${styles.icnTextarea}`}>
          {disabled ? (
            <input type="text" name={input.name} value={input.value} disabled />
          ) : (
            <DateTime
              value={input.value}
              onChange={param => {
                input.onChange(param)
              }}
              onBlur={() => {
                if (input.value.match(validators.jpYearRegExp)) {
                  input.value = toAdYearDate(input.value)
                }
                input.onBlur(input.value)
              }}
              dateFormat={dateFormat}
              timeFormat={false}
              {...rest}
              ref={dateTime => (this._dateTime = dateTime)}
            />
          )}

          <JpYearDate value={input.value} />
          <i onClick={() => this._dateTime && this._dateTime.openCalendar()}>
            <Calendar />
          </i>
        </div>
        <Diff diff={diff} />
        {example && <span className={styles.example}>{example}</span>}
        {description && <div className={styles.description}>{description}</div>}
        <Error meta={meta} label={label} />
      </div>
    )
  }
}

export class renderInlineDatePickerField extends Component {
  render() {
    const { input, meta: { touched, error }, options, width, ...rest } = this.props
    return (
      <div
        className={touched && error ? `${styles.icnTextarea} ${styles.invalid}` : `${styles.icnTextarea}`}
        style={{ width: `${width}px`, display: 'inline-block' }}>
        <DateTime
          value={input.value}
          onChange={param => input.onChange(param)}
          onBlur={() => {
            if (input.value.match(validators.jpYearRegExp)) {
              input.value = toAdYearDate(input.value)
            }
            input.onBlur(input.value)
          }}
          dateFormat={'YYYY/MM/DD'}
          timeFormat={false}
          {...options}
          ref={dateTime => (this._dateTime = dateTime)}
          {...rest}
        />
        <i onClick={() => this._dateTime.openCalendar()}>
          <Calendar />
        </i>
      </div>
    )
  }
}

export const renderTextAreaField = ({
  input,
  meta: { touched, error },
  label,
  placeholder = '',
  type,
  meta,
  rows = '10',
  icons,
  required,
  disabled,
  note,
  noteWidth,
  diff,
  description,
  isChangeLabelToAnchor
}) => (
  <div>
    <Label
      text={label}
      required={required}
      note={note}
      noteWidth={noteWidth}
      diff={diff}
      isChangeLabelToAnchor={isChangeLabelToAnchor}
    />
    <div className={styles.fieldWrap}>
      <div className={touched && error ? `${styles.icnTextarea} ${styles.invalid}` : `${styles.icnTextarea}`}>
        <textarea {...input} placeholder={placeholder} type={type} rows={rows} disabled={disabled} />
      </div>
      {icons && <div className={styles.icons}>{icons}</div>}
    </div>
    <Diff diff={diff} />
    {description && <div className={styles.description}>{description}</div>}
    <Error meta={meta} label={label} />
  </div>
)

const urlRegex = /https?:\/\/([^\s/?]+\.?)+(\/[^\s]*)?/

const renderAnchor = (url, idx) => (
  <a href={url} key={idx} target="_blank" className="u-txt-link" rel="noopener noreferrer">
    {url}
  </a>
)

export const renderTextWithAnchor = (text, idx = 0) => {
  const matchUrl = text.match(urlRegex)
  return matchUrl
    ? [
        text.slice(0, matchUrl.index),
        renderAnchor(matchUrl[0], idx),
        ...renderTextWithAnchor(text.slice(matchUrl.index + matchUrl[0].length), idx + 1)
      ]
    : [text]
}

export const arrowRenderer = ({ isOpen }) => (
  <i>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      transform={isOpen ? 'rotate(180)' : 'rotate(0)'}>
      <path fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2" d="M3.5 7l6.2 6.3L16 7" />
    </svg>
  </i>
)

const renderSelectField = ({
  input,
  required,
  label,
  meta,
  creatable,
  asyncOptions,
  options,
  note,
  noteWidth,
  placeholder = '選択してください',
  addBlankOption = !required,
  diff,
  changed,
  noLabel,
  description,
  isChangeLabelToAnchor,
  ...rest
}) => {
  const [addedOptions, setAddOptions] = useState([])
  useEffect(
    () => {
      if (
        creatable &&
        input.value &&
        !options.find(option => option.value === input.value) &&
        !addedOptions.find(option => option.value === input.value)
      ) {
        setAddOptions(addedOptions => [...addedOptions, { label: input.value, value: input.value }])
      }
    },
    [input.value, options, addedOptions, creatable]
  )

  let _options = addBlankOption ? [{ label: '\u200b', value: null }, ...options] : options

  const diffOption = options.find(option => option.value === diff)

  const Input = (creatable && Creatable) || (asyncOptions && Select.Async) || Select
  if (creatable) {
    _options = [..._options, ...addedOptions]
    rest.onNewOptionClick = option => {
      setAddOptions(addedOptions => [...addedOptions, option])
    }
    rest.promptTextCreator = label => `「${label}」を追加します`
  }
  return (
    <div className={meta.touched && meta.error ? `${styles.icnTextarea} ${styles.invalid}` : `${styles.icnTextarea}`}>
      <Label
        text={label}
        required={required}
        note={note}
        noteWidth={noteWidth}
        changed={changed}
        diff={diff}
        noLabel={noLabel}
        isChangeLabelToAnchor={isChangeLabelToAnchor}
      />
      <Input
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
        options={_options}
        placeholder={placeholder}
        simpleValue
        arrowRenderer={arrowRenderer}
        clearable={false}
        noResultsText="データが見つかりません"
        noOptionsMessage="データが見つかりません"
        {...rest}
      />
      <Diff diff={get(diffOption, 'label') || diff} />
      {description && <div className={styles.description}>{description}</div>}
      <Error meta={meta} label={label} />
    </div>
  )
}

export const Error = ({ meta: { touched, error }, label = '' }) => (
  <React.Fragment>
    {touched ? (
      error ? (
        <p className={styles.error}>
          <span>{`${label}${error}`}</span>
        </p>
      ) : null
    ) : null}
  </React.Fragment>
)

export const Note = ({ text }) => <p className={styles.note}>{text}</p>

const File = ({ file, invalid, onClick, disabled }) => (
  <div className={invalid ? `${styles.icnTextarea} ${styles.invalid} u-mt20` : `${styles.icnTextarea} u-mt20`}>
    {!disabled && (
      <i onClick={onClick}>
        <Delete size={20} />
      </i>
    )}
    <div className={`${styles.input} ${styles.disabled}`}>
      {file.url ? (
        <a href={file.url} download className={styles.downloadLink} target="_blank" rel="noopener noreferrer">
          {file.filename}
        </a>
      ) : (
        file.name
      )}
    </div>
  </div>
)

const FileDiff = ({ diff }) =>
  diff ? (
    <div className={`${styles.fileDiffField} u-mt20`}>
      <p className={styles.diffLabelText}>変更前</p>
      <div className={styles.fileDiffValue}>
        {diff.url ? (
          <a href={diff.url} download className={styles.downloadLink} target="_blank" rel="noopener noreferrer">
            {diff.filename}
          </a>
        ) : diff.filename ? (
          diff.filename
        ) : (
          '未入力'
        )}
      </div>
    </div>
  ) : null

export class renderFileField extends Component {
  static defaultProps = {
    accepted: '*',
    multiple: false,
    disablePreview: true
  }

  onDrop = acceptedFiles => {
    if (acceptedFiles) {
      this.setState({ files: acceptedFiles })
    }
    const { multiple, input: { onChange, value } } = this.props
    acceptedFiles.forEach(file => (file._id = uniqueId('file_')))
    return multiple ? onChange([...value, ...acceptedFiles]) : onChange(acceptedFiles[0])
  }

  handleBlur = () => {
    const { input: { onBlur, value } } = this.props
    return onBlur(value)
  }

  clear = () => {
    const { input: { onChange } } = this.props
    return onChange(null)
  }

  remove = index => {
    const { input: { value, onChange } } = this.props
    onChange(value.filter((file, i) => i !== index))
  }

  render() {
    /* eslint-disable no-unused-vars */
    const {
      input: { onBlur, value },
      required,
      meta,
      label,
      name,
      accept,
      multiple,
      note,
      noteWidth,
      disabled,
      disablePreview,
      diff,
      changed,
      description,
      isChangeLabelToAnchor
    } = this.props
    /* eslint-enable no-unused-vars */
    const Preview = this.props.preview

    return (
      <div>
        <Label
          text={label}
          required={required}
          note={note}
          noteWidth={noteWidth}
          changed={changed}
          diff={diff}
          isChangeLabelToAnchor={isChangeLabelToAnchor}
        />
        {!disabled && (
          <Dropzone
            accept={accept}
            onBlur={this.handleBlur}
            onDrop={this.onDrop}
            name={name}
            multiple={multiple}
            className="dropzone-input"
            disablePreview={disablePreview}>
            <div className={styles.icnTextarea}>
              <i>
                <Fileup />
              </i>
              <input
                type="text"
                className={meta.error && meta.touched ? styles.invalid : ''}
                readOnly
                placeholder="ファイルを選択 または ドラッグ＆ドロップ"
                value=""
              />
            </div>
          </Dropzone>
        )}
        {value &&
          (multiple ? (
            value.map((file, index) => (
              <File
                key={file.id || file._id}
                file={file}
                onClick={() => this.remove(index)}
                error={meta.touched && meta.error}
                disabled={disabled}
              />
            ))
          ) : (
            <File file={value} onClick={this.clear} error={meta.touched && meta.error} disabled={disabled} />
          ))}
        {!value && disabled && <input disabled type="text" />}
        {description && <div className={styles.description}>{description}</div>}
        <Error meta={meta} label={label} />
        {Preview && value && <Preview value={value} />}
        <FileDiff diff={diff} />
      </div>
    )
  }
}

export const BoxDouble = ({ children }) => <div className={styles.double}>{children}</div>

export const BoxTriple = ({ children }) => <div className={styles.triple}>{children}</div>

export const BoxInner = ({ children }) => <div className={styles.inner}>{children}</div>

export const Section = ({ title, children, error, icon, note, small, ...rest }) => (
  <section className={error ? `${styles.boxError}` : `${styles.box}`} {...rest}>
    {title && (
      <div className={small ? styles.boxHeadSmall : styles.boxHead}>
        {title}
        {note && <span className={styles.boxHeadNote}>{note}</span>}
        {icon && <span className={styles.boxHeadIcon}>{icon}</span>}
      </div>
    )}
    <div className={small ? styles.boxMainSmall : styles.boxMain}>{children}</div>
  </section>
)

export const dateFieldProps = {
  normalize: value => (isObject(value) && value.format ? value.format('YYYY/MM/DD') : value || ''),
  format: value => (isString(value) ? value.replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, '$1/$2/$3') : value || ''),
  validate: validators.date
}

const monthFieldProps = {
  viewMode: 'months',
  dateFormat: 'YYYY/MM',
  normalize: value => (isObject(value) && value.format ? value.format('YYYY/MM') : value || ''),
  format: value => (isString(value) ? value.replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, '$1/$2') : value || ''),
  validate: validators.monthYear
}

const validateToArray = validate => (validate && !isArray(validate) ? [validate] : validate || [])

const makeField = (component, type = 'text', otherProps = {}) => props => {
  const { refField, required, validate, label, name, note, noteWidth, ...rest } = { ...otherProps, ...props }
  return (
    <div className={styles.boxWrap}>
      <Field
        type={type}
        component={component}
        validate={[...validateToArray(validate), validators.requiredIf(required)]}
        required={required}
        ref={refField}
        name={name}
        label={label}
        note={note}
        noteWidth={noteWidth}
        {...rest}
      />
      <LabelMapper name={name} label={label} />
    </div>
  )
}

export const TextField = makeField(renderInputField)

export const DateField = makeField(renderDatePickerField, 'text', dateFieldProps)

export const MonthField = makeField(renderDatePickerField, 'text', monthFieldProps)

export const SelectField = makeField(renderSelectField)

export const CreatableField = makeField(renderSelectField, 'text', { creatable: true })

export const TextFieldWithKana = makeField(renderInputFieldWithKana)

export const RadioField = makeField(renderRadioField)

export const CheckboxField = makeField(renderCheckBoxField, 'checkbox')

export const FileField = (Field => props => (
  <Field {...props} validate={props.label ? validators.sizeBelow : validators.sizeBelowNoLabel} />
))(makeField(renderFileField))

export const TextAreaField = makeField(renderTextAreaField)

const withErrorField = Content => {
  const name = prefix => (prefix ? `_${prefix}` : '_fields')
  const renderContent = ({ meta, label, prefix, input, required, note, noteWidth, ...rest }) => (
    <div className={styles.boxWrap}>
      <Label text={label} required={required} note={note} noteWidth={noteWidth} />
      <div className={meta.touched && meta.error ? styles.invalid : undefined}>
        <Content {...rest} label={label} prefix={prefix} required={required} onBlur={() => input.onBlur()} />
      </div>
      <Error meta={meta} label={label} />
      <LabelMapper name={name(prefix)} label={label} />
    </div>
  )
  return ({ fieldsValidate, ...rest }) => (
    <Field validate={fieldsValidate} component={renderContent} name={name(rest.prefix)} {...rest} />
  )
}

export const NumberFields = ({
  label,
  prefix,
  required,
  texts,
  lengths,
  exactLength,
  needNumber = true,
  seperateChar = '_',
  indexOffset = 0,
  onBlur,
  note,
  noteWidth,
  diff,
  changed,
  disabled,
  description,
  isChangeLabelToAnchor,
  ...rest
}) => (
  <div className={styles.boxWrap}>
    <Label
      text={label}
      required={required}
      note={note}
      noteWidth={noteWidth}
      changed={changed}
      diff={diff}
      isChangeLabelToAnchor={isChangeLabelToAnchor}
    />
    {lengths.map((len, index) => {
      const name = `${prefix}${seperateChar}${index + indexOffset}`
      const text = index >= texts.length ? last(texts) : texts[index]
      return (
        <span key={`field_${name}`}>
          {text}
          <Field
            key={name}
            name={name}
            type="text"
            component={renderInlineInputField}
            width={15 * len + 20}
            maxLength={len}
            onBlur={onBlur}
            validate={[
              needNumber ? validators.number : validators.constUndef,
              validators.exactLengthNumber(exactLength ? len : null),
              validators.requiredIf(required)
            ]}
            required={required}
            disabled={disabled}
            {...rest}
          />
          <LabelMapper name={name} label={`${label}の${index + 1}番`} />
        </span>
      )
    })}
    {texts.length > lengths.length && texts[lengths.length]}
    {lengths.map((len, index) => {
      const name = `${prefix}${seperateChar}${index + indexOffset}`
      return (
        <Field
          name={name}
          component={Error}
          key={`error_${name}`}
          label={`${label}の${index + 1}番`}
          validate={[
            needNumber ? validators.number : validators.constUndef,
            validators.exactLengthNumber(exactLength ? len : null),
            validators.requiredIf(required)
          ]}
          required={required}
        />
      )
    })}
    <Diff diff={diff} />
    {description && <div className={styles.description}>{description}</div>}
  </div>
)

export const DateSpanFields = withErrorField(({ label, prefix, fieldProps, onBlur }) => {
  const { validate, ...rest } = dateFieldProps
  const withDateValidate = [validators.date, validate]
  const start_on = prefix ? `${prefix}_start_on` : 'start_on'
  const end_on = prefix ? `${prefix}_end_on` : 'end_on'
  return (
    <React.Fragment>
      <Field
        component={renderInlineDatePickerField}
        type="text"
        name={start_on}
        validate={withDateValidate}
        onBlur={onBlur}
        width={236}
        {...rest}
        {...(fieldProps ? fieldProps[0] : {})}
      />
      &nbsp;〜&nbsp;
      <Field
        component={renderInlineDatePickerField}
        type="text"
        name={end_on}
        validate={withDateValidate}
        onBlur={onBlur}
        width={236}
        {...rest}
        {...(fieldProps ? fieldProps[1] : {})}
      />
      <Field name={start_on} component={Error} label={`${label}の開始日`} validate={withDateValidate} {...rest} />
      <LabelMapper name={start_on} label={`${label}の開始日`} />
      <Field name={end_on} component={Error} label={`${label}の終了日`} validate={withDateValidate} {...rest} />
      <LabelMapper name={end_on} label={`${label}の終了日`} />
    </React.Fragment>
  )
})

export const CheckboxFields = ({ label, options }) => (
  <div className={styles.boxWrap}>
    <Label text={label} />
    {options.map(({ name, label }) => (
      <label key={`${name}_checkbox`} className="input-label">
        <Field component="input" type="checkbox" name={name} className="m-checkbox-input" />
        <span className="m-checkbox-parts">{label}</span>
      </label>
    ))}
  </div>
)
